import type { ClaimTaskResult, OperatorReinforcementOffer } from '@groupe-reca/contracts'
import type { LocalStore } from '@/platform/localStore'
import { runCommand } from '../commands'
import type { MissionRepository } from '../MissionRepository'

export type ClaimOutcome =
  | { kind: 'confirmed'; result: ClaimTaskResult }
  /** Une autre mission a pris la résidence : son nom, si le serveur le donne. */
  | { kind: 'taken'; by: string | null }
  /** Réponse perdue : la clé est gardée, le prochain essai rejoue la même demande (jamais une seconde attribution). */
  | { kind: 'pending' }
  | { kind: 'refused'; code: string }

export const claimScope = (offerId: string) => `claim:${offerId}`

/**
 * Prise en charge d'une résidence offerte (`claim_reinforcement_task_v1`) : version attendue de la tâche et clé
 * d'idempotence conservée sur la tablette. Seul le serveur attribue; rien n'est affiché comme confirmé avant lui.
 */
export async function claimOffer(
  store: LocalStore,
  repository: Pick<MissionRepository, 'claimTask'>,
  offer: Pick<OperatorReinforcementOffer, 'offerId' | 'taskVersion'>,
): Promise<ClaimOutcome> {
  const outcome = await runCommand(store, claimScope(offer.offerId), (idempotencyKey) =>
    repository.claimTask({ idempotencyKey, offerId: offer.offerId, expectedVersion: offer.taskVersion }),
  )
  if (outcome.kind === 'ok') return { kind: 'confirmed', result: outcome.value }
  if (outcome.kind === 'uncertain') return { kind: 'pending' }
  if (outcome.code === 'TASK_ALREADY_CLAIMED') return { kind: 'taken', by: outcome.detail?.trim() ? outcome.detail : null }
  return { kind: 'refused', code: outcome.code }
}
